import { BorderLessTableCell } from "../../../components/Table.styled"
import { getYears } from "./utils/helpers"

const YearHeader = () => {
  const currentYear = new Date().getFullYear()
  const years = getYears(currentYear - 1)
  return (
    <BorderLessTableCell>
      <div className="flex">
        {
          years.map(year => (
            <div key={year} className="year-header">
              {year}
            </div>
          ))
        }
      </div>
    </BorderLessTableCell>
  )
}

export default YearHeader